export class IDs {

    public static MOD_CORE = 'core';
    public static MOD_ETOOL = 'etool';
    public static MOD_ETOOL_ADMIN = 'etool_admin';

    public static ENT_DYNAMIC_VIEWS = 'dynamic_views';
    public static ENT_SYSTEM_OPTIONS = 'system_options';
    public static ENT_SYSTEM_RIGHTS = 'system_rights';

    public static ENT_ARCHIV_ITEMS = 'archiv_items'; // ACHTUNG ... zwar in core, aber trotzdem "alte" WIPS-Entity

    public static ENT_IMPORT_DEFINITIONS = 'import_definitions';
    public static ENT_IMPORT_LOG = 'import_log';

    public static ENT_BACKUP_INFO = 'import_backup_info';
    public static ENT_ONLINE_HILFE = 'online_hilfe';

    public static ENT_MAILBOX_IN = 'mailbox_in';
    public static ENT_MAILBOX_OUT = 'mailbox_out';
    public static ENT_APP_PARAMETER = 'application_parameter';

    public static ENT_CUSTOM_USER = 'user'; // Hier OHNE entity, da reguläre Entity


    public static ENT_LEGACY_USER = 'entity_user';  // Hier MIT entity, da legacy
    public static ENT_LEGACY_GROUPS = 'group_index';
    public static ENT_LEGACY_GROUP_ITEMS = 'group_items';
    public static ENT_LEGACY_ACCESS = 'access';
    public static ENT_LEGACY_ACCESS_USER = 'access_user';
    public static ENT_LEGACY_ACCESS_GROUPS = 'access_groups';


}
